<template lang="pug">
#graficoNdvi
    div(v-show='possuiDadosNDVI')
        apex-charts.component.apexcharts-canvas(
            type='line',
            height='300',
            :options='options',
            :series='series',
            ref='chart'
        )

    div(v-show='!possuiDadosNDVI')
        empty-result(
            :min-height='150',
            icon-class='mdi-alert-octagon',
            :message='noResultMessage'
        )
</template>

<script>
import ApexCharts from 'vue-apexcharts';
import { GRAFICO_MONITORAMENTO_NDVI } from '../../../utils/layouts/graficos';
import EmptyResult from '../../EmptyResult';

import { CodigoAcuracia } from '../../../constants/AcuraciaEnum';

export default {
    components: {
        ApexCharts,
        EmptyResult
    },

    props: {
        dadosMonitoramentoNDVI: {
            type: Array,
            require: true
        },
        dadosPrecipitacaoSafraAtual: {
            type: Array
        }
    },

    data() {
        return {
            dadosNDVI: null,
            dadosPrecipitacao: null,
            series: [],
            options: {
                legend: {
                    position: 'top'
                }
            },
            colors: []
        };
    },

    watch: {
        dadosMonitoramentoNDVI() {
            this.configure();
        }
    },

    computed: {
        possuiDadosNDVI() {
            return this.dadosNDVI && this.dadosNDVI.length;
        },
        noResultMessage() {
            return this.$t('mensagens.monitoramentoAgricola.naoHaIndiceVegetacao');
        }
    },

    methods: {
        configure() {
            this.dadosNDVI = this.dadosMonitoramentoNDVI;
            let dadosComuns = [];
            let datas = [];
            let dadosAcuracia = [];
            let color = '';

            this.dadosNDVI.map(dados => {
                let obj = {
                    dataProcessamento: new Date(dados.dataProcessamento).toLocaleDateString('pt-BR'),
                    ndviPercentual: dados.ndviPercentual
                };
                datas.push(obj.dataProcessamento);
                if (
                    [CodigoAcuracia.ACURACIA50, CodigoAcuracia.ACURACIA51A80, CodigoAcuracia.ACURACIA80].includes(dados.codigoAcuracia)
                ) {
                    if (dados.codigoAcuracia === CodigoAcuracia.ACURACIA50) {
                        color = 'var(--acuracia-cinquenta-color)';
                    }
                    if (dados.codigoAcuracia === CodigoAcuracia.ACURACIA51A80) {
                        color = 'var(--acuracia-cinquenta-oitenta-color)';
                    }
                    if (dados.codigoAcuracia === CodigoAcuracia.ACURACIA80) {
                        color = 'var(--acuracia-oitenta-color)';
                    }
                    dadosAcuracia.push(obj);
                } else {
                    dadosComuns.push(obj);
                }
            });

            let datasUnicas = [...new Set(datas)];

            datasUnicas.sort((a, b) => {
                const dateA = new Date(a.split('/').reverse().join('/'));
                const dateB = new Date(b.split('/').reverse().join('/'));
                return dateA - dateB;
            });

            if (dadosComuns.length <= 0) {
                dadosAcuracia = dadosAcuracia.sort((a, b) => a.data - b.data);

                GRAFICO_MONITORAMENTO_NDVI.colors = [color];
                this.options = Object.assign(GRAFICO_MONITORAMENTO_NDVI);

                this.options.xaxis.categories = [];

                this.options.xaxis.categories.push(...datasUnicas);

                let porcentagemNdviAcuracia = datasUnicas.map(data => {
                    const rangeExiste = dadosAcuracia.find(
                        range => range.dataProcessamento === data
                    );
                    if (rangeExiste) {
                        return rangeExiste.ndviPercentual / 100;
                    }
                    return null;
                });

                this.options.yaxis[0].min = 0;

                this.options.stroke.curve = [];

                this.options.stroke.curve[0] = porcentagemNdviAcuracia.filter(Boolean).length !== 0 ? 'smooth' : '';

                this.series = [
                    {
                        name: this.$t('mensagens.monitoramentoAgricola.visualizarImovel.blocoNdvi.indiceVegetacaoSoja'),
                        type: 'line',
                        data: porcentagemNdviAcuracia
                    }
                ];

                this.$refs.chart.updateOptions(this.options);
            } else {
                dadosComuns = dadosComuns.sort((a, b) => a.data - b.data);

                GRAFICO_MONITORAMENTO_NDVI.colors = ['#DC610D'];
                this.options = Object.assign(GRAFICO_MONITORAMENTO_NDVI);

                this.options.xaxis.categories = [];

                this.options.xaxis.categories.push(...datasUnicas);

                let porcentagemNdviDadosComuns = datasUnicas.map(data => {
                    const rangeExiste = dadosComuns.find(
                        range => range.dataProcessamento === data
                    );
                    if (rangeExiste) {
                        return rangeExiste.ndviPercentual / 100;
                    }
                    return null;
                });

                this.options.yaxis[0].min = 0;

                this.options.stroke.curve = [];

                this.options.stroke.curve[0] = porcentagemNdviDadosComuns.filter(Boolean).length !== 0 ? 'smooth' : '';

                this.series = [
                    {
                        name: this.$t('mensagens.monitoramentoAgricola.visualizarImovel.blocoNdvi.indiceVegetacao'),
                        type: 'line',
                        data: porcentagemNdviDadosComuns
                    }
                ];

                this.$refs.chart.updateOptions(this.options);
            }
        }
    },

    mounted() {
        this.configure();
    }
};
</script>

<style lang="scss">
.apexcharts-tooltip {
    background-color: white;
    border: 1px solid #e3e3e3;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    padding: 5px;
}

.apexcharts-tooltip .apexcharts-tooltip-title {
    background: #fff !important;
    align-self: flex-start;
    font-family: Arial, Helvetica, sans-serif;
    color: #333;
    border-bottom: 0px !important;
    font-weight: 600;
    font-size: 14px !important;
    padding: 5px;
    border-radius: 5px 5px 0 0;
}

.apexcharts-tooltip .apexcharts-tooltip-series-group {
    padding: 5px;
    display: flex;
    align-items: center;
}

.apexcharts-tooltip .apexcharts-tooltip-marker {
    width: 10px;
    height: 10px;
    margin-right: 5px;
}

.apexcharts-tooltip .apexcharts-tooltip-text {
    font-size: 12px;
    color: #333;
}

.apexcharts-tooltip .apexcharts-tooltip-text-y-label,
.apexcharts-tooltip .apexcharts-tooltip-text-y-value {
    display: inline-block;
}
</style>
